/**
 * Roles that may view compliance deletion audit (original content + metadata).
 * Aligns with AuthContext display roles for tenant administrators.
 */
export function isTeamChatAdminRole(role: string | undefined): boolean {
  if (!role) return false;
  if (role === 'Super Admin' || role === 'Customer Admin' || role === 'Tenant Owner') return true;
  return false;
}
